import { Avatar } from 'antd';
import React, { FC, useMemo } from 'react';
import { ContactAvatar } from '../contact_avatar/ContactAvatar';
import { getContactName } from '../../utils/DataFormatterUtils';
import { nullSafeGet } from '../../utils/DataAccessUtils';

const sampleTypingDetails = [
	{
		email: 'mprasanna+sm1@useopenwrench.com',
		nameGiven: 'Prasanna',
		nameFamily: 'SM',
		contactType: 'supplier',
		lastUpdated: 1772099687785,
	},
];

const NoteTypingDetailDisplay: FC<any> = ({ typingDetails, textValue }): React.ReactElement => {
	const sanitisedTypingDetails = useMemo(() => typingDetails || [], [typingDetails]);

	const contactAvatar = useMemo(
		() => (
			<Avatar.Group
				maxCount={2}
				maxPopoverTrigger="hover"
				size="small"
				maxStyle={{
					display: 'none',
					color: '#333',
					backgroundColor: 'transparent',
					cursor: 'pointer',
				}}
			>
				{sanitisedTypingDetails.map((c, i) => (
					<ContactAvatar
						key={`${i}-contact-avatar`}
						hidePopover={true}
						placement="bottomRight"
						contact={c}
					/>
				))}
			</Avatar.Group>
		),
		[sanitisedTypingDetails]
	);

	const names = useMemo(() => {
		const contactNames = sanitisedTypingDetails.map((_) => getContactName(_));

		if (contactNames.length === 1) {
			return contactNames[0];
		}

		if (contactNames.length === 2) {
			return `${contactNames[0]} and ${contactNames[1]}`;
		}

		const remainingCount = contactNames.length - 2;
		return `${contactNames[0]}, ${contactNames[1]} + ${remainingCount} others`;
	}, [sanitisedTypingDetails]);

	const typingMessage = useMemo(
		() => `${sanitisedTypingDetails.length > 1 ? 'are' : 'is'} typing...`,
		[sanitisedTypingDetails.length]
	);

	return (
		<div className="mb-2 h-5">
			{sanitisedTypingDetails.length > 0 ? (
				<div className="flex flex-row items-center gap-1">
					{contactAvatar}
					<div className="flex flex-row items-baseline gap-1">
						<div className="footnoteMedium text-[#595959]">{names}</div>
						<div className="text-[#00000073]">{typingMessage}</div>
					</div>
				</div>
			) : nullSafeGet('0', textValue) ? (
				<span style={{ color: 'rgba(0,0,0,0.45)', fontSize: 14 }}>Press ENTER to send</span>
			) : null}{' '}
		</div>
	);
};

export default NoteTypingDetailDisplay;
